import { render, staticRenderFns } from "./View-User-Doc.vue?vue&type=template&id=1bdae083&scoped=true&"
import script from "./View-User-Doc.vue?vue&type=script&lang=js&"
export * from "./View-User-Doc.vue?vue&type=script&lang=js&"
import style0 from "./View-User-Doc.vue?vue&type=style&index=0&id=1bdae083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdae083",
  null
  
)

export default component.exports